import React from "react";

export enum VerticalScale {
    dB,
    /** This is linear amplitude, but still shows the dB tick marks */
    amplitude,
}

export enum HorizontalScale {
    harmonics,
    octaves
}

export interface ChartOptions {
    verticalScale: VerticalScale,
    horizontalScale: HorizontalScale,
}

export const ChartContext = React.createContext<ChartOptions>({
    verticalScale: VerticalScale.dB, horizontalScale: HorizontalScale.harmonics
});

export function useChartOptions() {
    return React.useContext<ChartOptions>(ChartContext);
}